module.exports = __webpack_public_path__ + "img/enclosures-3.c16f3ba2.jpeg";